export default "__VITE_ASSET__CoPk7MRV__"